import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Box,
  Typography,
  Checkbox,
  Button,
  Switch,
  FormControlLabel,
  Grid,
  CircularProgress,
} from '@material-ui/core';

// import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'; // stripe

import SingleDialog from '../../../../CustomDialogs/SingleDialog';

import {
  DialogHeader,
  DialogContent,
  DialogActions,
} from '../../../../CustomDialogs';
import Style from './Style';
import {
  CheckedIconCancellation,
  BusinessPlusIcon,
  TorqueGrowthPkg,
  UncheckedIconCancellation,
  UniversalIcon,
} from '../../../../../constants';

//  ######## Stripe  ########
import { Toast } from '../../../../Toast/Toast';
import { payInvoice } from '../../../../../actions/subscription/subscription-actions';
import TextFieldComp from '../../../../TextFieldComp';
import CardSection from '../../billing/Stripe/CardSection';
//  ######## End Stripe  ########

// import Paypal from '../../billing/Paypal';
// import {
//   createSubscriptionApiPaypal,
//   updateSubscriptionApiPaypal,
// } from '../../../../../api/subscription/subscription-api';

const useStyles = makeStyles((theme) => Style(theme));

const Popup = ({ toggle, setToggle }) => {
  const classes = useStyles();

  const [periodToggle, setPeriodToggle] = React.useState('monthly');
  const [agreeTermsAndConds, setAgreeTermsAndConds] = useState(false);

  const plans = useSelector((state) => state.subscription?.plans || []);
  const subscribedPlan = useSelector(
    (state) => state?.subscription?.subscribedPlan,
  );
  const discountedPlanData = useSelector(
    (state) => state.subscription?.discountedPlanData,
  );

  const universalPlan = plans?.find(
    (p) => p.id === process.env.REACT_APP_UNIVERSAL_PLAN_ID_MONGO,
  );

  const businessPlusPlan = plans?.find(
    (p) => p.id === process.env.REACT_APP_BUSINESS_PLUS_PLAN_ID_MONGO,
  );

  const growthPlanData = plans?.find(
    (p) => p.id === process.env.REACT_APP_TORQUE_GROWTH_PLAN_ID_MONGO,
  );

  useEffect(() => {
    if (subscribedPlan?.durationToggle) {
      setPeriodToggle(subscribedPlan.durationToggle);
    }
  }, [subscribedPlan]);

  //  ######## Stripe  ########

  const updateSubscriptionLoading = useSelector(
    (state) => state.subscription?.updateSubscriptionLoading,
  );
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [createPmLoading, setCreatePmLoading] = useState(false);
  const [cardHolderName, setCardHolderName] = useState('');
  const [requiredFields, setRequiredFields] = useState({
    cardHolderName: '',
  });

  const handleChangeCardHolderName = async (e) => {
    const { name, value } = e.target;

    if (value?.length > 25) {
      return;
    }

    if (value?.length > 0 && requiredFields?.cardHolderName) {
      setRequiredFields({ ...requiredFields, [name]: false });
    }

    setCardHolderName(value);
  };

  const createStripePaymentMethod = async () => {
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }
    const cardElement = elements.getElement(CardElement);

    if (!cardElement) return '';

    setCreatePmLoading(true);

    const { error: err, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name: cardHolderName || '',
      },
    });
    setCreatePmLoading(false);

    if (err) {
      console.log('[err]', err);
      Toast('error', err.message);
    }
    return paymentMethod;
  };

  const handlePaymentValidation = () => {
    let err = false;
    const erros = {};

    // checking the required validation
    if (cardHolderName?.length < 1) {
      err = true;
      erros['cardHolderName'] = true;
    } else {
      erros['cardHolderName'] = false;
    }

    setRequiredFields({ ...erros });
    return err;
  };

  const handlePayNow = async () => {
    const planId = subscribedPlan?.subscriptionId || '';
    const stripePriceId = subscribedPlan?.stripePriceId || '';

    if (!planId || !stripePriceId) return;

    const cardError = handlePaymentValidation();

    if (cardError) {
      Toast('error', 'Card Holder Name is required');
      return;
    }

    const _cardData = await createStripePaymentMethod();

    if (!_cardData?.id) return;

    setLoading(true);

    await dispatch(
      payInvoice({
        cardData: _cardData,
        planId,
        stripePriceId,
      }),
    );
    setLoading(false);
  };
  // success or error case of pay invoice is defined in dashboard comp

  //  ######## End Stripe  ########

  const universalPlanPrice = universalPlan[periodToggle]?.price || '-';
  const universalPlanDuration = universalPlan[periodToggle]?.duration || '-';

  const businessPlusPlanPrice = businessPlusPlan[periodToggle]?.price || '-';
  const businessPlusPlanDuration =
    businessPlusPlan[periodToggle]?.duration || '-';

  const growthPlanPrice = growthPlanData[periodToggle]?.price || '-';
  const growthPlanDuration = growthPlanData[periodToggle]?.duration || '-';

  // ### Paypal ###

  // const onApprovePayment = async ({
  //   paypalSubscriptionId,
  //   duration,
  //   planMongoId,
  //   paypalPlanId,
  // }) => {
  //   try {
  //     const expiryDate = duration?.toLowerCase().search('month')
  //       ? moment().add(1, 'M')
  //       : moment().add(12, 'M');

  //     if (!subscribedPlan?.paypalSubscriptionId) {
  //       await createSubscriptionApiPaypal({
  //         subscriptionId: paypalSubscriptionId,
  //         mongoSubscriptionId: planMongoId,
  //         expiryDate,
  //         paypalPlanId,
  //       });
  //     } else {
  //       await updateSubscriptionApiPaypal({
  //         paypalSubscriptionId,
  //         expiryDate,
  //       });
  //     }
  //     setToggle(false);
  //     window.location.reload();
  //   } catch (err) {
  //     console.log('error', err);
  //   }
  // };

  // const planToSubscribe = {
  //   ...plans?.find(
  //     (plan) =>
  //       plan?.id ===
  //       (discountedPlanData?.discountedPlanMongoId ||
  //         subscribedPlan?.subscriptionId),
  //   )[discountedPlanData?.tenure || subscribedPlan?.durationToggle],
  //   planId: plans?.find(
  //     (plan) =>
  //       plan?.id ===
  //       (discountedPlanData?.discountedPlanMongoId ||
  //         subscribedPlan?.subscriptionId),
  //   ).id,
  // };

  // ### End Paypal ###

  return (
    <div>
      <SingleDialog
        styles={clsx(classes.new__ro__dialog, 'edit__card__dialog')}
        toggle={toggle}
      >
        <DialogHeader headerStyle={classes.header}>
          <div>
            <Typography className={classes.upgrade__plan__heading}>
              Update Plan
            </Typography>
            <Typography className={classes.semi__heading}>
              Your current subscription is being updated
            </Typography>
          </div>
          <div className='d-flex align-center'>
            <Typography
              className={clsx(
                classes.toggle__label,
                periodToggle === 'monthly' && classes.active__label,
              )}
            >
              Monthly
            </Typography>
            <Switch
              disabled
              checked={subscribedPlan?.durationToggle === 'annual'}
              name='periodToggle'
              className={classes.toggle__switch}
              inputProps={{
                'aria-label': 'secondary checkbox',
              }}
            />
            <Typography
              className={clsx(
                classes.toggle__label,
                periodToggle === 'annual' && classes.active__label,
              )}
            >
              Annual
            </Typography>
          </div>
        </DialogHeader>
        <DialogContent mainStyles={classes.content__height}>
          <Box className={classes.plans__checkbox__main__container}>
            {(discountedPlanData?.discountedPlanMongoId ||
              subscribedPlan?.subscriptionId) === universalPlan.id ? (
              <div
                className={clsx(
                  classes.checkbox__text__container,
                  classes.border__primary,
                )}
              >
                <div className='d-flex align-center'>
                  <UniversalIcon />
                  <div
                    className={clsx(
                      classes.package__details,
                      'package__details d-flex flex-col',
                    )}
                  >
                    <Typography
                      className={clsx(
                        classes.upgrade__heading,
                        classes.active__upgrade__heading,
                      )}
                    >
                      Universal
                    </Typography>
                    <Typography
                      className={clsx(
                        classes.upgrade__semi__heading,
                        classes.active__semi__heading,
                      )}
                    >
                      {universalPlanPrice}
                      <span className='sm__per'>{universalPlanDuration}</span>
                    </Typography>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}

            {(discountedPlanData?.discountedPlanMongoId ||
              subscribedPlan?.subscriptionId) === businessPlusPlan.id ? (
              <div
                className={clsx(
                  classes.checkbox__text__container,
                  classes.border__primary,
                )}
              >
                <div className='d-flex align-center'>
                  <BusinessPlusIcon />
                  <div
                    className={clsx(
                      classes.package__details,
                      'package__details d-flex flex-col',
                    )}
                  >
                    <Typography
                      className={clsx(
                        classes.upgrade__heading,

                        classes.active__upgrade__heading,
                      )}
                    >
                      Business Plus
                    </Typography>
                    <Typography
                      className={clsx(
                        classes.upgrade__semi__heading,

                        classes.active__semi__heading,
                      )}
                    >
                      {businessPlusPlanPrice}
                      <span className='sm__per'>
                        {businessPlusPlanDuration}
                      </span>
                    </Typography>
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}

            {(discountedPlanData?.discountedPlanMongoId ||
              subscribedPlan?.subscriptionId) === growthPlanData.id && (
              <div
                className={clsx(
                  classes.checkbox__text__container,
                  classes.border__primary,
                )}
              >
                <div className='d-flex align-center'>
                  <TorqueGrowthPkg />
                  <div
                    className={clsx(
                      classes.package__details,
                      'package__details d-flex flex-col',
                    )}
                  >
                    <Typography
                      className={clsx(
                        classes.upgrade__heading,
                        classes.active__upgrade__heading,
                      )}
                    >
                      Torque Growth
                    </Typography>
                    <Typography
                      className={clsx(
                        classes.upgrade__semi__heading,
                        classes.active__semi__heading,
                      )}
                    >
                      {growthPlanPrice}
                      <span className='sm__per'>{growthPlanDuration}</span>
                    </Typography>
                  </div>
                </div>
              </div>
            )}
          </Box>
          <Typography className={classes.payment__details}>
            Payment Details
          </Typography>
          <div className={classes.terms__n__condition}>
            <Grid container className='inputs__main__div'>
              <Grid item className='grid__gapping' xs={12}>
                {/* <Paypal
                  planToSubscribe={planToSubscribe}
                  subscriptionID={subscribedPlan?.paypalSubscriptionId}
                  onApprovePayment={onApprovePayment}
                  discountedPlanData={discountedPlanData}
                /> */}

                {/* #### Stripe ### */}
                <TextFieldComp
                  id='cardHolderName'
                  name='cardHolderName'
                  label='Card Holder Name*'
                  placeholder='Enter Name'
                  value={cardHolderName}
                  onChange={handleChangeCardHolderName}
                  error={requiredFields?.cardHolderName}
                />
                <CardSection />
                {/* #### End Stripe ### */}
              </Grid>
            </Grid>

            <FormControlLabel
              className='formlabel__control'
              control={
                <Checkbox
                  icon={<UncheckedIconCancellation fontSize='small' />}
                  checkedIcon={<CheckedIconCancellation fontSize='small' />}
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  checked={agreeTermsAndConds}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  className='main__checkbox'
                  onChange={() => setAgreeTermsAndConds(!agreeTermsAndConds)}
                />
              }
              label='I agree to the Terms & Conditions'
            />
            <Typography className={classes.form__control__label}>
              By confirming your subscription, you allow Torque360 Inc. to
              charge your card for this and future payments in accordance with{' '}
              <a
                rel='noreferrer'
                target='_blank'
                href='https://www.torque360.co/terms-conditions/'
              >
                terms & conditions
              </a>
              . You can always cancel your subscription.
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.back__btn}
            onClick={() => setToggle(false)}
          >
            Back
          </Button>
          {/* ### Stripe ###  */}
          <Button
            className={clsx(
              classes.pay__now__btn,
              (!agreeTermsAndConds ||
                updateSubscriptionLoading ||
                loading ||
                createPmLoading) &&
                classes.disabled__btn,
            )}
            disabled={
              !agreeTermsAndConds ||
              updateSubscriptionLoading ||
              createPmLoading ||
              loading
            }
            onClick={handlePayNow}
          >
            Pay Now
            {(updateSubscriptionLoading || createPmLoading || loading) && (
              <CircularProgress className={classes.spinner} size={12} />
            )}
          </Button>
          {/* ### End Stripe ###  */}
        </DialogActions>
      </SingleDialog>
    </div>
  );
};

export default Popup;
